<template>
  <v-card outlined class="rounded-lg">
    <v-card-title>Nachrichten</v-card-title>
    <v-data-table
      height="200px"
      :items="nachrichten"
      fixed-header
      hide-default-header
      hide-default-footer
      :items-per-page="-1"
      no-data-text="Keine Nachrichten vorhanden"
    >
      <template v-slot:item="{ item }">
        <div @click="nachricht = item">
          <v-list three-line class="py-0 ma-1 font-weight-bold elevation-0">
            <v-list-item>
              <v-list-item-avatar>
                <v-img :src="'/static/wappen_klein.webp'"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-html="item.von"></v-list-item-title>
                <v-list-item-subtitle v-html="item.text"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <div>{{ $filters.date(item.datum, "DD.MM.YYYY") }}</div>
                <div>{{ $filters.date(item.datum, "hh:mm") }} Uhr</div>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  export default {
    props: ["bbr"],
    computed: {
      nachrichten() {
        if (this.$store.state.mails.loaded === false) {
          this.$store.dispatch("mails/loadMails");
        }
        return this.$store.getters["mails/eigeneMails"](this.bbr);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// mailsListe.vue?57f05240